"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var SvgAttachment = function (props) { return (React.createElement("svg", __assign({ "data-testid": "ICON_ATTACHMENT", width: "1em", height: "1em", viewBox: "0 0 16 16" }, props),
    React.createElement("path", { d: "M13.634 5.484c-2.62 2.641-4.071 4.064-6.69 6.706-1.132 1.141-2.98 1.128-4.128-.03-1.148-1.158-1.161-3.022-.03-4.164l4.288-4.288a.987.987 0 0 0 .002-1.392.981.981 0 0 0-1.391-.003L1.4 6.599c-1.887 1.902-1.865 5.01.049 6.94 1.913 1.93 4.994 1.951 6.88.048l6.69-6.706c1.32-1.332 1.305-3.507-.035-4.857C13.645.673 11.49.657 10.17 1.989L4.163 8.006c-.755.761-.746 2.004.02 2.776.765.772 1.997.78 2.751.02L9.78 7.949a1.971 1.971 0 0 0 0-2.783l1.775-1.779a1.45 1.45 0 0 1 2.064.015c.574.579.58 1.51.015 2.082Z" }))); };
exports.default = SvgAttachment;
